import React, { useState } from 'react';

import { getBase64 } from '../../infrastructure/utils/common';
import { HubSpotUser } from '../../schemas/HubSpotUserSchema';
import { AccountManagerDetails } from '../../schemas/UserSchema';
import { PhotoInfo } from '../../types/PhotoInfo';
import PhotoWidget from '../utils/FormWidgets/PhotoWidget';

import HubSpotUserSelector from './HubSpotUserSelector';

export type AccountManagerDetailsUpdates =
  Partial<
    Pick<AccountManagerDetails, "hubspotUserId" | "fullName" | "meetingLink"> &
    { avatar: PhotoInfo }
  >;

type Props = {
  details: AccountManagerDetails;
  onChange: (updates:AccountManagerDetailsUpdates) => void;
}

const AccountManagerDetailsSection = (props: Props) => {
  const [, setHubspotUser] = useState<HubSpotUser>()
  const [accountManagerAvatar, setAccountManagerAvatar] = useState<PhotoInfo | undefined>(props.details.avatar ? { isNew: false, data: props.details.avatar } : undefined);
  const [meetingLink, setMeetingLink] = useState<string>(props.details?.meetingLink || "");

  const handleAccountManagerAvatarChange = async (event) => {
    const { target } = event;
    if (target.files.length === 0) {
      return;
    }

    const icon = await getBase64(target.files[0]);
    const avatar = {
      isNew: true,
      blob: target.files[0],
      data: icon as string,
    };
    setAccountManagerAvatar(avatar);

    props.onChange({
      avatar
    })
  }

  return <div className='data-box'>
    <h4>Account manager details</h4>

    <p>Hubspot user:</p>
    <div className="row">
      <div className="col-md-6 col-lg-4 form-group">
        <HubSpotUserSelector
          onSelect={(val) => {
            setHubspotUser(val);
            props.onChange({
              hubspotUserId: val.userId,
              fullName: `${val.firstName} ${val.lastName}`
            })
          }}
          initialValue={props.details.hubspotUserId ?? -1}
          />
      </div>
    </div>

    <p>Avatar:</p>
    <div className="row">
      <div className="col-md-6 col-lg-4 form-group">
        <PhotoWidget
          header={'avatar'}
          onChange={handleAccountManagerAvatarChange}
          image={accountManagerAvatar}
        />
      </div>
    </div>

    <p>Meeting Link:</p>
    <div className="row">
      <div className="col-md-6 col-lg-4">
        <input className='form-control' type="url" placeholder="https://meetings.hubspot.com/..."
          value={meetingLink}
          onChange={(e) => {
            setMeetingLink(e.target.value);
            props.onChange({
              meetingLink: e.target.value
            })
          }} />
      </div>
    </div>
  </div>
}

export default AccountManagerDetailsSection;
